import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileText = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.16634 1.1665H3.49967C3.19026 1.1665 2.89351 1.28942 2.67472 1.50821C2.45592 1.72701 2.33301 2.02375 2.33301 2.33317V11.6665C2.33301 11.9759 2.45592 12.2727 2.67472 12.4915C2.89351 12.7103 3.19026 12.8332 3.49967 12.8332H10.4997C10.8091 12.8332 11.1058 12.7103 11.3246 12.4915C11.5434 12.2727 11.6663 11.9759 11.6663 11.6665V4.6665L8.16634 1.1665Z",
			stroke: "#004A96",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.16699 1.1665V4.6665H11.667",
			stroke: "#004A96",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.33366 7.5835H4.66699",
			stroke: "#004A96",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.33366 9.9165H4.66699",
			stroke: "#004A96",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.83366 5.25H5.25033H4.66699",
			stroke: "#004A96",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFileText;
